export const CLASS_NAME = 'cst-icon-view-on-map'
